import { createQueryKeySet } from '~/utils/query-keys';
import { useQuery } from '@tanstack/react-query';
import { SSF } from '~/apis/api';

export const keys = createQueryKeySet<StandardRecordListQueryParams>('standard-records');

export type StandardRecordListQueryParams = Parameters<typeof SSF.api.standardRecordsList>[0];

export function useStandardRecordListQuery(params?: StandardRecordListQueryParams, enabled = true) {
  return useQuery({
    queryFn: async () => {
      const { data } = await SSF.api.standardRecordsList(params);
      return data;
    },
    queryKey: keys.list(params),
    enabled,
  });
}

export function useStandardRecordQuery(id: number) {
  return useQuery({
    queryFn: async () => {
      const { data } = await SSF.api.standardRecordsRetrieve(id);
      return data;
    },
    queryKey: keys.detail(id),
  });
}
